import { i18n, LanguageCode } from '@app/modules/i18n-locales';
import { LANGUAGE_DEFAULT } from '@app/modules/i18n-locales/i18n';

export const getCurrentLang = (): LanguageCode => {
  const lang =
    i18n?.language && Object.values(LanguageCode).includes(i18n?.language as LanguageCode)
      ? i18n.language.toLowerCase()
      : LANGUAGE_DEFAULT;
  return lang as LanguageCode;
};
